let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Jaof")).then(() => parcelRequire('fyq5j'));